import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import TextInput from '@adsk/alloy-react-text-input';
import { T } from '../../../helpers/i18n';
import { useRfiForm } from '../../RfiFormProvider';
import { CommonFormField } from '../../../components';
import { ISSUE_ATTRIBUTE_NAMES } from '../../../constants/issue-attribute-names';
import { RfiCreateFormValues } from '../../types';

type CommonTextProps = {
  fieldName: 'title' | 'locationDescription' | 'reference';
  label: string;
};

const CommonText = ({ fieldName, label }: CommonTextProps) => {
  const formik = useFormikContext<RfiCreateFormValues>();
  const { mandatoryFields, isSubmitting, refs } = useRfiForm();
  const isFieldsMandatory = mandatoryFields.includes(fieldName);
  const errorMessage = formik.touched[fieldName] && formik.errors[fieldName];
  return (
    <CommonFormField
      label={T.translate(label)}
      required={isFieldsMandatory}
      error={errorMessage}
      ref={refs[fieldName]}
    >
      <TextInput
        name={fieldName}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values[fieldName]}
        error={!!errorMessage}
        disabled={isSubmitting}
      />
    </CommonFormField>
  );
};

CommonText.propTypes = {
  fieldName: PropTypes.oneOf(Object.values(ISSUE_ATTRIBUTE_NAMES)).isRequired,
  label: PropTypes.string.isRequired,
};

export default CommonText;
